let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQCI6")).then(() => parcelRequire('jeltG'));